import { AdminInfoCard } from "@/components/admin";

const InfoCard = () => {
  return (
    <AdminInfoCard
      title="소리 분석 기준"
      description="소리 분석 결과는 수집된 소리의 자동 판정값을 운영자가 확인하기 위한 참고 정보입니다. 위험 신호는 긴급 이벤트와 생활 모니터링 화면에서 같은 시간대의 상태를 함께 확인합니다."
      tone="slate"
    />
  );
};

export default InfoCard;
